import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHeart = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.2177 3.35849L11.2263 3.35062L11.2347 3.34248C11.7654 2.82595 12.4098 2.4411 13.1163 2.21884C13.8227 1.99659 14.5714 1.94314 15.3022 2.06277C16.0331 2.18241 16.7257 2.4718 17.3243 2.9077C17.9227 3.34335 18.4106 3.9132 18.7488 4.57151C19.1915 5.44212 19.3453 6.43114 19.1878 7.39508C19.0303 8.3595 18.5693 9.24858 17.872 9.93317L17.8656 9.93944L17.8594 9.94585L10.0597 17.9772C10.0596 17.9773 10.0596 17.9774 10.0595 17.9774C10.0518 17.9853 10.0425 17.9916 10.0324 17.9959C10.0221 18.0002 10.0111 18.0025 9.99992 18.0025C9.98878 18.0025 9.97776 18.0002 9.96749 17.9959C9.95723 17.9916 9.94794 17.9852 9.94017 17.9772L2.12975 9.93098L2.12386 9.92492L2.11784 9.91899C1.4236 9.2353 0.965301 8.34815 0.80948 7.38631C0.65366 6.42448 0.808423 5.43801 1.25131 4.5701L1.25132 4.5701L1.2533 4.56616C1.58523 3.90612 2.06986 3.33481 2.66694 2.8997C3.26402 2.46459 3.95631 2.17823 4.6863 2.06441L4.68631 2.06448L4.69598 2.06284C5.43113 1.93834 6.18537 1.99111 6.89603 2.21675C7.60668 2.44239 8.25321 2.83438 8.78189 3.36016L8.7936 3.37181L8.80582 3.38293L9.49498 4.01043L10.001 4.47119L10.5061 4.00932L11.2177 3.35849Z",
		stroke: "#8C94AA",
		strokeWidth: 1.5
	})
});
const ForwardRef = forwardRef(SvgHeart);
export default ForwardRef;
